import { createSlice } from '@reduxjs/toolkit';
import { DASHBOARD, DashboardState } from './types';

const initialState: DashboardState = {
  isAdjusting: false,
};

export const dashboardSlice = createSlice({
  name: DASHBOARD,
  initialState,
  reducers: {
    setIsAdjusting: state => {
      state.isAdjusting = !state.isAdjusting;
    },
  },
});

export const { setIsAdjusting } = dashboardSlice.actions;
export default dashboardSlice.reducer;
